import NiotaClassicApiService from '@/services/niotaClassicApiService';
import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import pullAt from 'lodash/pullAt';

export default {
  data: function () {
    return {
      isLoading: false,
      deviceData: [],
    };
  },
  computed: {
    requiredRule() {
      return [(v) => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    euiRules() {
      return [
        (v) =>
          (!!v && /^([0-9A-F]{16})$/gi.exec(v.trim()) !== null) ||
          this.$i18n_tc('DigitalTwin.DigitalTwin.copy.euiRule', 16 * 4, { n: 16 * 4 }),
      ];
    },
  },
  watch: {
    twinObject() {
      this.setupAssetTwin();
    },
  },
  mounted() {
    this.setupAssetTwin();
  },
  methods: {
    setupAssetTwin(deviceIds = null) {
      if (!get(this.twinObject, 'data.assetManagement')) {
        this.twinObject.data.assetManagement = { deviceIds: [] };
        this.twinObject.data = cloneDeep(this.twinObject.data);
      }
      if (deviceIds || this.twinObject.data.assetManagement.deviceIds) {
        let promises = (deviceIds || this.twinObject.data.assetManagement.deviceIds).map((deviceId) => {
          return NiotaClassicApiService.deviceGetDetails(deviceId);
        });
        Promise.all(promises)
          .then((res) => {
            this.deviceData = res.map((devData) => {
              return {
                deviceEui: devData.data.device.eui,
                deviceId: devData.data.device.id,
                deviceTitle: devData.data.device.title,
                deviceType: devData.data.device.deviceType,
                properties: devData.data.device.properties,
              };
            });
          })
          .catch((error) => {
            console.error(error);
            let errorMessage = get(error, 'response.data.message', error.message);
            let errorOutput = this.$i18n_te(`Error.${errorMessage}`)
              ? this.$i18n_t(`Error.${errorMessage}`)
              : this.$i18n_t(errorMessage);
            this.$snack(errorOutput, 'error');
            return {
              id: null,
              eui: `${this.$i18n_t('NiotaClassic.Devices.snacks.notFound')}`,
            };
          });
      }
    },

    fetchIotHubDetails(i) {
      if (!this.deviceData[i].deviceEui || /^([0-9A-F]{16})$/gi.exec(this.deviceData[i].deviceEui.trim()) === null) {
        return;
      }
      this.deviceData[i].deviceId = null;
      this.deviceData[i].deviceTitle = null;
      this.deviceData = cloneDeep(this.deviceData);

      return this.fetchIotHubDeviceDetails(this.deviceData[i].deviceEui).then((details) => {
        this.deviceData[i].deviceEui = details.eui;
        this.deviceData[i].deviceId = details.id;
        this.deviceData[i].deviceTitle = details.title;
        this.deviceData[i].deviceType = details.deviceType;
        this.deviceData[i].properties = details.properties;
        this.deviceData = cloneDeep(this.deviceData);
      });
    },
    fetchIotHubDeviceDetails(eui) {
      const trimmedEui = (!eui || typeof eui !== 'string' ? '' : eui).trim();
      if (!eui || typeof eui !== 'string' || /^([0-9A-F]{16})$/gi.exec(trimmedEui) === null) {
        return Promise.resolve({
          id: null,
          eui: `${this.$i18n_t('NiotaClassic.Devices.snacks.notFound')}`,
        });
      }
      this.isLoading = true;
      return NiotaClassicApiService.devicesFind(trimmedEui, 0, 1, 'title', 'ASC')
        .then((res) => {
          let device = get(res, 'data.device') || get(res, 'data.devices[0]');
          if (!device || !device.id) {
            throw new Error('NIOTA_DEVICE_NOT_FOUND');
          }
          return {
            id: device.id,
            title: device.title,
            eui: device.eui,
            deviceType: device.deviceType,
            properties: device.properties,
          };
        })
        .catch((error) => {
          console.error(error);
          let errorMessage = get(error, 'response.data.message', error.message);
          let errorOutput = this.$i18n_te(`Error.${errorMessage}`)
            ? this.$i18n_t(`Error.${errorMessage}`)
            : this.$i18n_t(errorMessage);
          this.$snack(errorOutput, 'error');
          return {
            id: null,
            eui: `${trimmedEui} ${this.$i18n_t('NiotaClassic.Devices.snacks.notFound')}`,
          };
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    addNewDevice(index) {
      this.twinObject.data.assetManagement.deviceIds.splice(index + 1, 0, -1);
      this.deviceData.splice(index + 1, 0, {});
      this.deviceData = cloneDeep(this.deviceData);
    },
    removeDevice(index) {
      pullAt(this.twinObject.data.assetManagement.deviceIds, [index]);
      pullAt(this.deviceData, [index]);
      this.deviceData = cloneDeep(this.deviceData);
    },
    changeDeviceOrder(index, direction) {
      if (index === 0 && direction === 'up') {
        return;
      }
      if (index === this.deviceData.length - 1 && direction === 'down') {
        return;
      }

      const offset = direction === 'up' ? -1 : 1;

      const deviceId = this.twinObject.data.assetManagement.deviceIds[index];
      pullAt(this.twinObject.data.assetManagement.deviceIds, [index]);
      this.twinObject.data.assetManagement.deviceIds.splice(index + offset, 0, deviceId);

      const deviceData = this.deviceData[index];
      pullAt(this.deviceData, [index]);
      this.deviceData.splice(index + offset, 0, deviceData);

      this.deviceData = cloneDeep(this.deviceData);
    },
  },
};
